export default __webpack_public_path__ + "static/media/product-overview-bg.1d25254d.webp";